import React, { useState, forwardRef, useImperativeHandle } from 'react';

import MUIDataTable from "mui-datatables";

import Preloader from "../Preloader/Preloader";

import { fetch_transaction_history } from "../../services/api_calls/table_fetch";
import { get_cookies } from '../Cookies/Cookies';

const DynamicTable = forwardRef((props, ref) => {

	const { 
		title,
		columns, 
		rows,
		setRows,
		url,
		dateRange,
		iscodesonly,
		filterOption,
		selectableRows = 'none',
		custom_function = {}
	} = props;

	const new_title = (title || "").split(" ").map( x => x[0].toUpperCase() + x.substr(1)).join(" ");
	const print_title = (title || "").split(" ").map( x => x[0].toUpperCase() + x.substr(1)).join("");
	const jc_u_idno = get_cookies('branchidno');
	const [dataLoaded, setDataLoaded] = useState(false);
	const [dataTable, setDataTable] = useState({
		page: 0,
		sizePerPage: 10,
        idno_filter: "",
        relstats_filter: "",
        soldto_filter: "",
        accttype_filter: "",
        country_filter: "",
        delivery_filter: "",
        package_filter: "",
        promo_filter: "",
        packstats_filter: "",
		query: "",
		count: 0,
		position_id : "",
		sort: 'id',
		sortorder: 'DESC',
		search: '',
		initialSort: true
	});

	useImperativeHandle(ref, () => ({
    onFetchApi: () => dataFilter()
  }));

	const dataFilter = async (obj) => {		
		setDataLoaded(false);
		const response = await fetch_transaction_history(
			url, 
			dateRange, obj?.rowsPerPage || dataTable.sizePerPage, 
			obj?.page || dataTable.page,
			obj?.sort || dataTable.sort,
			dataTable.sortorder,
			dataTable.search,
			iscodesonly, jc_u_idno,
			filterOption
		);
		// const response = await fetch_transaction_history(url, dateRange, obj?.rowsPerPage || dataTable.sizePerPage, obj?.page || dataTable.page, dataTable, iscodesonly, filterOption, position_id);
		if(response !== "error"){
			
			if((obj || {}).hasOwnProperty('sort')){
				setDataTable(prevState => ({
					...prevState,
					page: response.data.current_page-1,
					count: response.data.total,
					sort: obj.sort,
					sizePerPage: parseInt(response.data.per_page, 10),
					sortorder: dataTable.sortorder === 'DESC' ? 'ASC' : 'DESC',
					search: '',
					initialSort: false
				}));	
			}else{
				setDataTable(prevState => ({
					...prevState,
					page: response.data.current_page-1,
					count: response.data.total,
					sizePerPage: parseInt(response.data.per_page, 10),
					search: ''
				}));
			}

			setRows(response.data.data);
			setDataLoaded(true);
		}else{
			console.error(response);
		}
	}

	const onChangeRowPerPage = async (value) => await dataFilter({rowsPerPage: value});
	const onChangePage = async (value) => await dataFilter({page: value + 1});
	const onChangeSort = async (sort) => await dataFilter({sort});
	const empty = Boolean((rows || []).length !== 0); //const empty =rows == 0 ? false : true;	
	const options = {
		// customSort: (data, colIndex, order) => { console.log({data, colIndex, order}) },
		serverSide: true,
		sortOrder: {
			name: dataTable.initialSort ? '' : dataTable.sort, 
			direction: dataTable.sortorder.toLowerCase() === 'desc' ? 'asc' : 'desc'
		},
		sort: true,
		filter: false,
		count: dataTable.count,
		viewColumns: false,
		page: dataTable.page,
		selectableRows: selectableRows,
		selectableRowsHeader: true,
		customToolbarSelect: () => {},
		filterType: "multiselect",
		responsive: "standard",
		rowsPerPage: dataTable.sizePerPage,
		searchPlaceholder: 'Press Enter to Search',
		searchProps: {
			onKeyPress:(e) => {
				if(e.key === "Enter"){
					if(!['', ' '].includes(dataTable.search)){
						dataFilter();
					}
				}
			}
		},
		onTableChange: (action, tableState) => {
			switch(action){
				case 'changePage': 	
					onChangePage(tableState.page)
					break;
				case 'changeRowsPerPage':
					onChangeRowPerPage(tableState.rowsPerPage)
					break;
				case 'sort':
					onChangeSort(tableState.sortOrder.name, tableState.sortOrder.direction); //direction - backend=sortorder //name - backend=sort
					break;
				case 'search':
					setDataTable(prevState => ({ ...prevState, search: tableState.searchText }));					
					break;
				case 'rowSelectionChange':
					switch(url){
						case 'activationcardshqlist':
							custom_function.receiveActivationHandler(tableState);
							break;
						default:
							break;
					}
					break;
				default: 
					break;
			}
		},
		setFilterChipProps: (colIndex, colName, data) => {
			return {
				color: "primary",
				variant: "outlined",
				className: "testClass123",
			};
		},
		download: false,
		print: false,
		downloadOptions: {
			filename : `${print_title.replace(/\s/g, '')}.csv`//change filename of csv
		}
	}

	//filter data

	return(
		dataLoaded ? 
			<MUIDataTable
				title={
					<div>
						<h3 className="header-title" style ={{color: "#339933"}}>{new_title}</h3>
					</div>
				}
				data={rows || []}
				columns={columns}
				options={options}
			/> :
			<Preloader />
	);
		
	
});

export default DynamicTable;